import { render, staticRenderFns } from "./customerBusinessStatistics.vue?vue&type=template&id=004b7caa&scoped=true"
import script from "./customerBusinessStatistics.vue?vue&type=script&lang=js"
export * from "./customerBusinessStatistics.vue?vue&type=script&lang=js"
import style0 from "./customerBusinessStatistics.vue?vue&type=style&index=0&id=004b7caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004b7caa",
  null
  
)

export default component.exports